export default "__VITE_ASSET__CZdecIVo__"